import { render, staticRenderFns } from "./DocumentPortalWelcome.vue?vue&type=template&id=6116ae3b&scoped=true&"
import script from "./DocumentPortalWelcome.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalWelcome.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalWelcome.vue?vue&type=style&index=0&id=6116ae3b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116ae3b",
  null
  
)

export default component.exports